var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm._m(0)
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [
      _c("img", { attrs: { src: "/static/icon-error.svg" } }),
      _vm._v(" "),
      _c("h3", [_vm._v("Ops, encontramos um problema!")]),
      _vm._v(" "),
      _c("div", { staticClass: "text" }, [
        _c("p", [
          _vm._v(
            "\n      Aconteceu um possível erro na criação do seu ticket e o nosso time de suporte pode não ter recebido a sua solicitação.\n    "
          )
        ]),
        _vm._v(" "),
        _c("p", [
          _c("b", [
            _vm._v(
              "Tente novamente e, caso o erro persista, entre em contato utilizando o nosso chat localizado no canto inferior direito!"
            )
          ]),
          _c("br"),
          _vm._v(" "),
          _c("b", [_vm._v("Fique atento ao seu email")]),
          _vm._v(
            ". Caso a sua solicitação tenha chegado, enviaremos uma resposta automática informando o recebimento."
          ),
          _c("br"),
          _c("br"),
          _vm._v(
            "\n      Não esqueça de verificar a sua caixa de spam 😉\n    "
          )
        ])
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-408dfbe6", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-408dfbe6","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Order/Components/Actions/Cancellation/Error.vue
// module id = null
// module chunks = 